export default "__VITE_ASSET__D0HW4_pO__"